import {
  FormLabel,
  FormControl,
  Textarea as ChakraTextarea,
  Text,
} from "@chakra-ui/react";
import { useField } from "formik";

const TextArea = ({
  label,
  name = "",
  placeholder,
  labelColor,
  disabled = false,
  disabledStyle,
  maxLength = 300, // optional prop
}) => {
  const [field, meta] = useField(name);

  return (
    <FormControl isInvalid={meta.touched && !!meta.error}>
      <FormLabel
        color={labelColor || "#000000"}
        mb={2}
        fontFamily="PlusJakartaSansMedium"
        fontSize="12px"
        textTransform="capitalize"
      >
        {label}
      </FormLabel>

      <ChakraTextarea
        {...field}
        placeholder={placeholder}
        bg="transparent"
        fontFamily="PlusJakartaSansRegular"
        borderRadius="4px"
        fontSize="12px"
        isDisabled={disabled}
        _disabled={disabledStyle}
        color="#000000"
        maxLength={maxLength}
        _placeholder={{ color: "#898989" }}
      />

      <Text
        pos="absolute"
        bottom={2}
        right={2}
        color="grey.300"
        zIndex={2}
        fontFamily="PlusJakartaSansRegular"
        fontSize="8px"
        letterSpacing={2}
      >
        {(field.value || "").length}/{maxLength}
      </Text>

      {meta.touched && meta.error && (
        <Text
          color="#FF0000"
          fontSize="12px"
          fontFamily={"PlusJakartaSansRegular"}
          lineHeight={"20px"}
        >
          {meta.error}
        </Text>
      )}
    </FormControl>
  );
};

export default TextArea;
